// extracted by mini-css-extract-plugin
export var phone = "_2y-0";